export default "__VITE_ASSET__e18a8592__"